import { periodType } from '@/store/common.types'
import { Level, University } from '@/store/master/types';
import { Moment } from 'moment'
import { Pager } from '@/store/pager.types'
import { Point } from '@/store/students/types'

export const TaskType = {
  classRecord: 'classRecord',
  frs: 'frs',
}
export type TaskTypeCode = keyof typeof TaskType

export const DeadlineType = {
  classRecord: 'classRecord',
  frs: 'frs',
  preparation: 'preparation',
}
export type DeadlineTypeCode = keyof typeof DeadlineType

export interface DeadlinesState {
  deadlines: Deadline[],
  pager: Pager,
  each: { deadlines: Deadline[], pager: Pager }[]
}
export interface Deadline {
  id: string,
  expired: Moment,
  isLate: boolean,
  isSend: boolean,
  comment: string,
  type: DeadlineTypeCode,
  isWaitingApproved: boolean,
  lesson: {
    id: string,
    datetime: Moment,
    dayofweek: string,
    period: periodType,
    level: Level,
    comment: string|null,
    section: {
      name: string,
    },
    unit: string,
    fiscalyear: number,
  },
  tutor: {
    tutorId: string,
    name: string,
  },
  students: Student[],
}

export interface DeadlineWaitingApproved {
  id: string,
  expired: Moment,
  isLate: boolean,
  isSend: boolean,
  comment: string,
  type: DeadlineTypeCode,
  isWaitingApproved: boolean,
  lesson: {
    id: string,
    datetime: Moment,
    dayofweek: string,
    period: periodType,
    level: Level,
    comment: string|null,
    unit: string,
    tutorName: string,
  },
}

export interface Student {
  id: string,
  nameJp: string,
  name: string,
  comment: string|null,
  wetecTotalScore: number,
  points?: Point[],
}

export interface DeadlineConditions {
  tutor?: string|null,
  university?: University|null
  deadlineInTimes?: string[],
  deadlineSends?: string[],
  deadlineFrom?: Moment|null,
  deadlineTo?: Moment|null,
  lessonDateFrom?: Moment|null,
  lessonDateTo?: Moment|null,
  levels?: Level[],
  types?: DeadlineTypeCode[],
  periods?: periodType[],
  ids?: string[],
}

export interface DeadlineExpiredUpdateParams {
  ids: string[],
  expired: Moment,
  comment: string,
}

export interface Lesson {
  id: string,
  date: Moment,
  period: periodType,
  level: Level,
  comment: string,
  section: {
    name: string,
  },
  unit: string,
  dayofweek?:string,
}
